module.exports = __webpack_public_path__ + "static/media/Raleway-ExtraBold.c9503ab0.ttf";